import React from "react";
import classNames from "classnames";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./FormSelect.scss";

export function FormSelect({
  placeholder,
  value,
  change,
  error,
  errorText,
  options,
  disabled,
}) {
  const [t] = useTranslation();

  const textError = { "inleverFormSelect-text-error": error };

  return (
    <div className="inleverFormSelect">
      <Form.Select
        className={classNames("inleverFormSelect-text", textError)}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(x) => change(x.target.value)}
      >
        {options.map((x, i) => (
          <option
            key={"option-" + x.id + "-" + i}
            className="select-option"
            value={x.id}
          >
            {t(x.name)}
          </option>
        ))}
      </Form.Select>
      <span className="inleverFormSelect-errorText">
        {error ? errorText : " "}
      </span>
    </div>
  );
}
